import React from "react";

const ResetPassword = () => {
  return (
    <div>
      <style>
        {`
        @media (max-width: 576px) {
          #offcanvasResetPassword {
            width: 90% !important;
          }
        }

        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasResetPassword {
            width: 55% !important;
          }
        }

        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasResetPassword {
            width: 30% !important;
          }
        }
          
        @media (min-width: 1441px)  {
          #offcanvasResetPassword {
            width: 20% !important;
          }
        }
        `}
      </style>
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasResetPassword"
        aria-labelledby="offcanvasResetPasswordLabel"
      >
        <div className="offcanvas-header d-flex justify-content-between align-items-center">
          <h5 id="offcanvasResetPasswordLabel">Reset Password</h5>
          <div className="d-flex align-items-center ms-auto">
            <button
              type="submit"
              className="btn btn-sm btn-outline-success me-2"
              title="reset"
              data-bs-dismiss="offcanvas"
            >
              <i className="fa fa-check fs-4"></i>
            </button>
            <button
              type="button"
              className="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
        </div>
        <hr className="m-0" />
        <div className="offcanvas-body">
          <form>
            {/* <div className="mb-3">
        <label className="form-label">User Email</label>
        <input
          type="email"
          className="form-control"
          placeholder="Enter user email"
          required
        />
      </div> */}
            <div className="mb-3">
              <label className="form-label">New Password</label>
              <input
                type="password"
                className="form-control"
                placeholder="Enter new password"
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Confirm Password</label>
              <input
                type="password"
                className="form-control"
                placeholder="Confirm new password"
                required
              />
            </div>
            {/* <div className="d-flex justify-content-end">
        <button
          type="button"
          className="btn btn-secondary me-2"
          data-bs-dismiss="offcanvas"
        >
          Cancel
        </button>
        <button type="submit" className="btn btn-primary">
          Reset Password
        </button>
      </div> */}
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
